import React, { useEffect, useState } from "react";
import classes from "./Newitemproducts.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import Footer from "../../Components/Footer/Footer";
import { useLocation } from "react-router-dom";
import { Trash2, Upload } from "lucide-react";
import Select from "react-select";
import api, { BASE_URL, withCompanyId } from "../../Components/API/Api";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import * as XLSX from 'xlsx';
import { useUser } from "../../UserContext";

const Newitemproducts = () => {
  const { user } = useUser();
  const userRole = (user?.role || user?.user_type || user?.account_type || user?.type || '').toLowerCase();
  const isSuperAdmin = userRole === 'super admin' || userRole === 'superadmin' || userRole === 'super_admin';
  const [type, setType] = useState("products");
  const [productOptions, setProductOptions] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [products, setProducts] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  // const [unitDiscount, setUnitDiscount] = useState("");
  const [unitOfMeasurement, setUnitOfMeasurement] = useState("");
  const [reOrderLevel, setReOrderLevel] = useState("");
  const [description, setDescription] = useState("");
  const [services, setServices] = useState([]);
  const [taxOptions, setTaxOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stockClassifications, setStockClassifications] = useState([]);
  // Per-row inputs will be stored inside invoiceItems; keep only bulk upload-related state at top level



  const [invoiceItems, setInvoiceItems] = useState([
    {
      name: '',
      short_name: '',
      description: '',
      stock_classification: '',
      stock_category: '',
      qty: 0,
      unit_price: 0,
      // unit_discount: 0,
      unit_of_measurement: '',
      re_order_level: 0
    }
  ]);
  const [accounts, setAccounts] = useState([]);
  const [selectedIncomeGL, setSelectedIncomeGL] = useState(null);
  const [selectedIncomeL, setSelectedIncomeL] = useState(null);
  const [selectedReceivablesGL, setSelectedReceivablesGL] = useState(null);
  const [loading, setLoading] = useState(true);
  const [stockCategories, setStockCategories] = useState([]);
  const [productService, setProductService] = useState("");
  const [shortName, setShortName] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [bulkStockClassification, setBulkStockClassification] = useState("");
  const [bulkStockCategory, setBulkStockCategory] = useState("");
  const [stores, setStores] = useState([]);
  const [loadingStores, setLoadingStores] = useState(false);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  // Add Category modal and integration states
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newCategoryDescription, setNewCategoryDescription] = useState("");
  const [isCreatingCategory, setIsCreatingCategory] = useState(false);
  const [pendingCategoryRowIndex, setPendingCategoryRowIndex] = useState(null);
  const [pendingBulkAdd, setPendingBulkAdd] = useState(false);

  const token = localStorage.getItem("authToken");
  const handleCreateStock = async () => {
    setIsSubmitting(true);

    try {
      if (isSuperAdmin && !selectedStoreId) {
        Swal.fire({
          icon: "warning",
          title: "Select a Store",
          text: "Please select a store before creating products.",
        });
        return;
      }
      // Collect rows with at least one key identifier
      const rows = invoiceItems.filter(item => (
        (item.name && item.name.trim()) ||
        (item.description && item.description.trim()) ||
        (item.short_name && item.short_name.trim())
      ));

      if (rows.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Nothing to create",
          text: "Please fill at least one row before saving.",
        });
        return;
      }
      // Build array-based payload per backend spec
      const payload = {
        name: rows.map(item => item.name || ''),
        short_name: rows.map(item => item.short_name || ''),
        description: rows.map(item => item.description || ''),
        unit_price: rows.map(item => Number(item.unit_price) || 0),
        quantity: rows.map(item => Number(item.qty) || 0),
        stock_classification: rows.map(item => item.stock_classification || ''),
        stock_category: rows.map(item => item.stock_category || ''),
        unit_of_measurement: rows.map(item => item.unit_of_measurement || ''),
        re_order_level: rows.map(item => Number(item.re_order_level) || 0),
        ...(isSuperAdmin && selectedStoreId ? { store_id: selectedStoreId } : {})
      };

        const response = await api.post(
        `${BASE_URL}/v1/create_stock`,
        withCompanyId(payload),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (response?.data?.status) {
        Swal.fire({
          icon: "success",
          title: "Products created",
          text: `Successfully created ${rows.length} product(s).`,
        }).then(() => {
          window.location.reload();
        });
        return;
      }

      // Handle validation errors in the expected format
      const apiMessage = response?.data?.message;
      if (apiMessage && typeof apiMessage === 'object') {
        const fieldErrors = Object.entries(apiMessage)
          .map(([field, msgs]) => `${field}: ${(Array.isArray(msgs) ? msgs : [msgs]).join(' | ')}`)
          .join('\n');
        Swal.fire({
          icon: "error",
          title: "Validation errors",
          text: "Please review the following: \n" + fieldErrors,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Creation failed",
          text: response?.data?.message || "Failed to create products.",
        });
      }
    } catch (error) {
      const apiMessage = error?.response?.data?.message;
      if (apiMessage && typeof apiMessage === 'object') {
        const fieldErrors = Object.entries(apiMessage)
          .map(([field, msgs]) => `${field}: ${(Array.isArray(msgs) ? msgs : [msgs]).join(' | ')}`)
          .join('\n');
        Swal.fire({
          icon: "error",
          title: "Validation errors",
          text: "Please review the following: \n" + fieldErrors,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Request Failed",
          text: apiMessage || error.response?.data?.error || error.message,
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDownloadTemplate = async () => {
    try {
      const response = await api.get(
        `${BASE_URL}/v1/download_stock_template`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
          responseType: 'blob', // Important for file downloads
        }
      );

      // Create a blob URL from the response data
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = 'stock_template.xlsx'; // Default filename

      // Append to DOM, click, and cleanup
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the blob URL
      window.URL.revokeObjectURL(url);

      // Show success message
      Swal.fire({
        icon: "success",
        title: "Template Downloaded!",
        text: "Stock template has been downloaded successfully.",
      });
    } catch (error) {
      console.error("Error downloading template:", error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Failed to download the template. Please try again.",
      });
    }
  };

  const showExpectedFormat = () => {
    Swal.fire({
      icon: "info",
      title: "Expected Excel Format",
      html: `
         <div style="text-align: left;">
           <p><strong>Your Excel file should have these headers in the first row:</strong></p>
           <ul style="margin: 1rem 0; padding-left: 1rem;">
             <li><strong>NAME</strong> - Product or service name (required)</li>
             <li><strong>SHORT NAME</strong> - Short name or code</li>
             <li><strong>DESCRIPTION</strong> - Product description</li>
             <li><strong>UNIT PRICE</strong> - Unit price</li>
             <li><strong>QUANTITY</strong> - Initial quantity</li>
             <li><strong>UNIT DISCOUNT</strong> - Discount amount</li>
             <li><strong>UNIT OF MEASUREMENT</strong> - Unit of measurement (e.g., kg, pcs)</li>
             <li><strong>RE-ORDER LEVEL</strong> - Reorder level</li>
             <li><strong>STOCK ID</strong> - Stock identifier (optional)</li>
           </ul>
           <p><strong>Note:</strong> At least one of NAME, DESCRIPTION, or SHORT NAME must have data.</p>
           <p><strong>Example:</strong></p>
           <div style="background: #f5f5f5; padding: 0.5rem; border-radius: 4px; font-family: monospace; font-size: 12px;">
             NAME | SHORT NAME | DESCRIPTION | QUANTITY | UNIT PRICE<br/>
             Laptop Dell | LAP001 | Dell Laptop | 10 | 500000
           </div>
           <p><strong>Important:</strong> Stock Classification and Category will be set from the dropdowns above.</p>
         </div>
       `,
      confirmButtonText: "Got it!",
      width: "600px"
    });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel', // .xls
        'text/csv' // .csv
      ];

      if (!validTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: "Invalid File Type",
          text: "Please upload an Excel file (.xlsx, .xls) or CSV file.",
        });
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "File Too Large",
          text: "Please upload a file smaller than 5MB.",
        });
        return;
      }

      setUploadedFile(file);
      Swal.fire({
        icon: "success",
        title: "File Selected Successfully!",
        text: `${file.name} has been selected. Please choose stock classification and category, then click "Process & Upload".`,
      });
    }
  };

  const processExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          // Convert to JSON with header row
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          console.log("Raw Excel data:", jsonData);

          if (jsonData.length < 2) {
            reject(new Error("Excel file must have at least a header row and one data row"));
            return;
          }

          // Extract headers and data
          const headers = jsonData[0];
          const rows = jsonData.slice(1);

          // More flexible header mapping with common variations
          const headerMapping = {
            // Product/Service variations
            'Product/Service': 'name',
            'Product/Service Name': 'name',
            'Product': 'name',
            'Service': 'name',
            'Name': 'name',
            'Product Name': 'name',
            'Service Name': 'name',
            'NAME': 'name',

            // Short Name variations
            'Short Name': 'short_name',
            'ShortName': 'short_name',
            'Short': 'short_name',
            'Code': 'short_name',
            'SKU': 'short_name',
            'SHORT NAME': 'short_name',

            // Description variations
            'Description': 'description',
            'Desc': 'description',
            'Details': 'description',
            'Notes': 'description',
            'DESCRIPTION': 'description',

            // Stock Classification variations
            'Stock Classification': 'stock_classification',
            'Classification': 'stock_classification',
            'Class': 'stock_classification',
            'Type': 'stock_classification',
            'STOCK CLASSIFICATION': 'stock_classification',

            // Stock Category variations
            'Stock Category': 'stock_category',
            'Category': 'stock_category',
            'Cat': 'stock_category',
            'Group': 'stock_category',
            'STOCK CATEGORY': 'stock_category',

            // Quantity variations
            'Quantity': 'quantity',
            'Qty': 'quantity',
            'Amount': 'quantity',
            'Count': 'quantity',
            'QUANTITY': 'quantity',

            // Price/Rate variations
            'Price/Rate': 'unit_price',
            'Price': 'unit_price',
            'Rate': 'unit_price',
            'Unit Price': 'unit_price',
            'Cost': 'unit_price',
            'UNIT PRICE': 'unit_price',

            // Discount variations
            'Discount': 'unit_discount',
            'Disc': 'unit_discount',
            'Discount %': 'unit_discount',
            'Discount Amount': 'unit_discount',
            'UNIT DISCOUNT': 'unit_discount',

            // Unit variations
            'Unit': 'unit_of_measurement',
            'Unit of Measurement': 'unit_of_measurement',
            'UOM': 'unit_of_measurement',
            'Measurement': 'unit_of_measurement',
            'UNIT OF MEASUREMENT': 'unit_of_measurement',

            // Re-order Level variations
            'Re-order Level': 're_order_level',
            'Reorder Level': 're_order_level',
            'Min Level': 're_order_level',
            'Minimum': 're_order_level',
            'RE-ORDER LEVEL': 're_order_level',

            // Additional variations for your specific format
            'STOCK ID': 'stock_id'
          };

          console.log("Headers found:", headers);
          console.log("Number of data rows:", rows.length);

          // Debug: Check which headers are being mapped
          headers.forEach((header, index) => {
            if (header && header.trim() !== '') {
              const mappedField = headerMapping[header.trim()];
              console.log(`Header "${header}" -> maps to: ${mappedField || 'UNMAPPED'}`);
            }
          });

          // Process each row
          const processedData = rows.map((row, index) => {
            const item = {};

            headers.forEach((header, colIndex) => {
              if (header && header.trim() !== '') { // Skip empty headers
                const mappedField = headerMapping[header.trim()];
                if (mappedField && row[colIndex] !== undefined && row[colIndex] !== null && row[colIndex] !== '') {
                  item[mappedField] = row[colIndex];
                }
              }
            });

            // Set default values for required fields
            if (!item.quantity) item.quantity = 0;
            if (!item.unit_price) item.unit_price = 0;
            // if (!item.unit_discount) item.unit_discount = 0;
            if (!item.re_order_level) item.re_order_level = 0;

            // Log each processed item for debugging
            console.log(`Row ${index + 1}:`, item);

            return item;
          }).filter(item => {
            // More flexible filtering - check if item has at least a name or description
            const hasValidData = item.name || item.description || item.short_name;
            if (!hasValidData) {
              console.log(`Filtered out row:`, item);
            }
            return hasValidData;
          });

          console.log("Final processed data:", processedData);
          console.log("Number of valid items:", processedData.length);

          if (processedData.length === 0) {
            reject(new Error(`No valid data found. Headers: ${headers.join(', ')}. Please check your Excel format.`));
            return;
          }

          resolve(processedData);
        } catch (error) {
          console.error("Error in processExcelFile:", error);
          reject(error);
        }
      };

      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsArrayBuffer(file);
    });
  };

  const clearUploadedFile = () => {
    setUploadedFile(null);
    setBulkStockClassification("");
    setBulkStockCategory("");
    setIsUploading(false);
  };

  const openAddCategoryModal = (rowIndex = null, isBulk = false) => {
    setPendingCategoryRowIndex(rowIndex);
    setPendingBulkAdd(!!isBulk);
    setNewCategoryName("");
    setNewCategoryDescription("");
    setShowAddCategoryModal(true);
  };

  const handleCreateCategory = async () => {
    const token = localStorage.getItem("authToken");
    if (!newCategoryName || !newCategoryName.trim()) {
      Swal.fire({ icon: 'warning', title: 'Name required', text: 'Please provide a category name.' });
      return;
    }
    setIsCreatingCategory(true);
    try {
      const payload = { name: newCategoryName.trim(), description: newCategoryDescription };
      const response = await api.post(
        `${BASE_URL}/v1/stock_category/create`,
        withCompanyId(payload),
        { headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' } }
      );

      const created = response?.data?.data || response?.data || null;
      if (response?.data?.status && created) {
        // Normalize created object if it's nested
        const newCat = Array.isArray(created) ? created[0] : created;
        setStockCategories(prev => Array.isArray(prev) ? [...prev, newCat] : [newCat]);

        // If a row was pending, set its stock_category to the new id
        if (pendingCategoryRowIndex !== null) {
          const updated = [...invoiceItems];
          updated[pendingCategoryRowIndex] = {
            ...updated[pendingCategoryRowIndex],
            stock_category: newCat.id
          };
          setInvoiceItems(updated);
        }

        // If bulk add was pending, set bulk select
        if (pendingBulkAdd) {
          setBulkStockCategory(newCat.id);
        }

        Swal.fire({ icon: 'success', title: 'Category created', text: `Category "${newCat.name || newCategoryName}" created.` });
        setShowAddCategoryModal(false);
        setPendingCategoryRowIndex(null);
        setPendingBulkAdd(false);
      } else {
        Swal.fire({ icon: 'error', title: 'Creation failed', text: response?.data?.message || 'Failed to create category.' });
      }
    } catch (error) {
      console.error('Error creating category:', error);
      Swal.fire({ icon: 'error', title: 'Request Failed', text: error.response?.data?.message || error.message || 'Failed to create category.' });
    } finally {
      setIsCreatingCategory(false);
    }
  };

  const handleUploadProducts = async () => {
    if (!uploadedFile) {
      Swal.fire({
        icon: "warning",
        title: "No File Selected",
        text: "Please select a file to upload first.",
      });
      return;
    }

    if (isSuperAdmin && !selectedStoreId) {
      Swal.fire({
        icon: "warning",
        title: "Select a Store",
        text: "Please select a store before uploading products.",
      });
      return;
    }

    // Validate that classification and category are selected
    if (!bulkStockClassification) {
      Swal.fire({
        icon: "warning",
        title: "Stock Classification Required",
        text: "Please select a stock classification before uploading.",
      });
      return;
    }

    if (!bulkStockCategory) {
      Swal.fire({
        icon: "warning",
        title: "Stock Category Required",
        text: "Please select a stock category before uploading.",
      });
      return;
    }

    setIsUploading(true);

    try {
      // Show confirmation dialog
      const result = await Swal.fire({
        icon: "question",
        title: "Confirm Upload",
        html: `
           <p>Ready to upload Excel file <strong>${uploadedFile.name}</strong> with:</p>
           <ul style="text-align: left; margin: 1rem 0;">
             <li><strong>Classification:</strong> ${stockClassifications.find(c => c.id === bulkStockClassification)?.name || bulkStockClassification}</li>
             <li><strong>Category:</strong> ${stockCategories.find(c => c.id === bulkStockCategory)?.name || bulkStockCategory}</li>
           </ul>
           <p>The backend will process the Excel file and create the products.</p>
           <p>Do you want to proceed?</p>
         `,
        showCancelButton: true,
        confirmButtonText: "Yes, Upload",
        cancelButtonText: "Cancel",
      });

      if (!result.isConfirmed) {
        return;
      }

      // Upload the file directly to the backend
      try {
        const formData = new FormData();
        formData.append('file', uploadedFile);
        formData.append('stock_classification', bulkStockClassification);
        formData.append('stock_category', bulkStockCategory);
        if (isSuperAdmin && selectedStoreId) {
          formData.append('store_id', selectedStoreId);
        }

        const response = await api.post(
          `${BASE_URL}/v1/upload_stocks`,
          withCompanyId(formData),
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        if (response.data.status) {
          // Show success message
          Swal.fire({
            icon: "success",
            title: "Upload Complete!",
            text: `Successfully uploaded Excel file. The backend is processing your products.`,
          });
        } else {
          // Show error message from API
          Swal.fire({
            icon: "error",
            title: "Upload Failed",
            text: response.data.message || "Failed to upload products.",
          });
        }
      } catch (error) {
        console.error("Error uploading stocks:", error);
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: error.response?.data?.message || error.message || "Failed to upload products.",
        });
      }

      // Reset file and selections
      setUploadedFile(null);
      setBulkStockClassification("");
      setBulkStockCategory("");

    } catch (error) {
      console.error("Error processing file:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: `Error processing file: ${error.message}`,
      });
    } finally {
      setIsUploading(false);
    }
  };

  useEffect(() => {
    const fetchStockClassifications = async () => {
      try {
        const token = localStorage.getItem("authToken"); // ✅ get token here
        const res = await api.get(
          `${BASE_URL}/v1/fetch_stock_classification`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.status && Array.isArray(res.data.data)) {
          setStockClassifications(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching stock classifications:", err);
      }
    };

    fetchStockClassifications();
  }, []);
  useEffect(() => {
    // Fetch Stores for Super Admins only
    const fetchStores = async () => {
      if (!isSuperAdmin) return;
      setLoadingStores(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get(
          `${BASE_URL}/v1/store`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );
        let storesData = [];
        if (res.data?.data?.data) storesData = res.data.data.data;
        else if (res.data?.data) storesData = res.data.data;
        else if (Array.isArray(res.data)) storesData = res.data;
        setStores(Array.isArray(storesData) ? storesData : []);
      } catch (err) {
        console.error("Error fetching stores:", err);
        setStores([]);
      } finally {
        setLoadingStores(false);
      }
    };

    fetchStores();
  }, [isSuperAdmin]);

  useEffect(() => {

    const token = localStorage.getItem("authToken");
    api.get(`${BASE_URL}/v1/stock_category`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((res) => {
        if (res.data.status) {
          setStockCategories(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching stock categories:", err);
      });
  }, []);

  const handleAddRow = () => {
    setInvoiceItems(prev => [
      ...prev,
      {
        name: '',
        short_name: '',
        description: '',
        stock_classification: '',
        stock_category: '',
        qty: 0,
        unit_price: 0,
        // unit_discount: 0,
        unit_of_measurement: '',
        re_order_level: 0
      }
    ]);
  };

  const handleDeleteRow = (index) => {
    const newItems = [...invoiceItems];
    newItems.splice(index, 1);
    setInvoiceItems(newItems);
  };


  const location = useLocation();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  // const fetchProducts = async () => {
  // Replace with your API call
  //   setProducts([
  //     { name: "Product A", price: 100 },
  //     { name: "Product B", price: 200 },
  //   ]);
  // };
  // const fetchServices = async () => {
  // Replace with your API call
  //   setServices([
  //     { name: "Service A", price: 150 },
  //     { name: "Service B", price: 250 },
  //   ]);
  // };

  // Fetch data when type changes
  // React.useEffect(() => {
  //   if (type === "products") fetchProducts();
  //   else fetchServices();
  // }, [type]);

  // Fetch currencies for the Currency select




  const handleChange = (index, field, value) => {
    const updatedItems = [...invoiceItems];
    const item = { ...updatedItems[index] };

    if (field === 'qty' || field === 'unit_price' || field === 're_order_level') {
      const num = value === '' ? '' : Number(value);
      item[field] = num === '' ? '' : (isNaN(num) ? 0 : num);
    } else {
      item[field] = value;
    }

    updatedItems[index] = item;
    setInvoiceItems(updatedItems);
  };



  useEffect(() => {
    const fetchAccounts = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const res = await api.get(
          `${BASE_URL}/v1/account`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        const dataArray = Array.isArray(res.data?.data) ? res.data.data : [];

        console.log("Fetched Accounts:", dataArray.length);
        setAccounts(dataArray);
      } catch (error) {
        console.error("Error fetching accounts:", error);
        setAccounts([]);
      }
    };

    fetchAccounts();
  }, []);
  const receivableAccounts = accounts
    .filter(acc => acc.subcategory?.description === "Accounts Receivables")
    .map(acc => ({
      value: acc.id,
      label: acc.gl_name
    }));
  const incomeAccounts = accounts
    .filter(acc => acc.class?.description === "Income")
    .map(acc => ({
      value: acc.id,
      label: acc.gl_name
    }));

  console.log("Receivable Accounts for Select:", receivableAccounts);
  console.log("Income Accounts for Select:", incomeAccounts);

  useEffect(() => {
    if (!invoiceDate || !dueDate) return; // Wait until both dates are picked

    const sendDatesToAccountAPI = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const res = await api.get(
          `${BASE_URL}/v1/account`,
          {
            params: {
              manufacted_date: invoiceDate,
              expiry_date: dueDate
            },
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json"
            }
          }
        );

        console.log("Account API response with dates:", res.data);
      } catch (error) {
        console.error("Error calling account API with dates:", error);
      }
    };

    sendDatesToAccountAPI();
  }, [invoiceDate, dueDate]);

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>New Products and Services</h2>
          <h1 className={classes.Titles}>Manage all your Products and Services.</h1>
        </header>

        <form className={classes.form}>
          {isSuperAdmin && (
            <div className={classes.group1}>
              <label>Store</label>
              <div className={classes.inputLoaderWrap}>
                <Select
                  isClearable
                  isSearchable
                  isDisabled={loadingStores}
                  placeholder={loadingStores ? 'Loading stores...' : 'Select store'}
                  options={stores.map((store) => ({
                    value: String(store.id),
                    label: store.name || store.store_name || store.title || `Store ${store.id}`
                  }))}
                  value={(() => {
                    const options = stores.map((store) => ({
                      value: String(store.id),
                      label: store.name || store.store_name || store.title || `Store ${store.id}`
                    }));
                    return options.find(o => o.value === String(selectedStoreId)) || null;
                  })()}
                  onChange={(option) => setSelectedStoreId(option?.value || "")}
                />
                {loadingStores && (
                  <span className={classes.ellipsisLoader} aria-hidden="true">
                    <span className={classes.dot}></span>
                    <span className={classes.dot}></span>
                    <span className={classes.dot}></span>
                  </span>
                )}
              </div>
            </div>
          )}
          {/* <div className={classes.group}>
            <label>Income GL</label>
            <Select
              placeholder="Select Receivable GL"
              options={incomeAccounts}
              value={selectedIncomeGL}
              onChange={setSelectedIncomeGL}
            />
          </div>

          <div className={classes.group2}>
            <label>Receivables GL</label>
            <Select
              placeholder="Select Income GL"
              options={incomeAccounts}
              value={selectedIncomeL}
              onChange={setSelectedIncomeL}
            />
          </div> */}
          <div className={classes.group1}>
            <label>Manufactured Date</label>
            <input
              type="date"
              value={invoiceDate}
              onChange={e => setInvoiceDate(e.target.value)}
              required
            />
          </div>
          <div className={classes.group1}>
            <label>Expired Date</label>
            <input
              type="date"
              value={dueDate}
              onChange={e => setDueDate(e.target.value)}
              required
            />
          </div>
        </form>
        <div className={classes.invoicecont}>
          <div className={classes.tabcontaineractionbtn}>
            <div style={{ marginBottom: "1rem" }}>
              <button
                type="button"
                className={type === "products" ? classes.activeTab : classes.inactiveTab}
                onClick={() => setType("products")}
              >
                Products
              </button>
              <button
                type="button"
                className={type === "services" ? classes.activeTab : classes.inactiveTab}
                onClick={() => setType("services")}
              >
                Services
              </button>
            </div>

            <div style={{ marginBottom: "1rem" }}>
              <button
                type="button"
                className={classes.activeTab}
                onClick={() => document.getElementById('fileInput').click()}
              >
                <Upload size={16} style={{ marginRight: '8px' }} />
                Upload Products
              </button>
              <button
                type="button"
                className={classes.inactiveTab}
                onClick={handleDownloadTemplate}
              >
                Download Template
              </button>
              {/* <button
                 type="button"
                 className={classes.inactiveTab}
                 onClick={showExpectedFormat}
                 style={{ marginLeft: "0.5rem" }}
               >
                 📋 Format Help
               </button> */}


              {/* File upload section */}
              {uploadedFile && (
                <div style={{
                  marginBottom: "1rem",
                  padding: "1rem",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9"
                }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem" }}>
                    <div>
                      <strong>Selected File:</strong> {uploadedFile.name}
                      <br />
                      <small>Size: {(uploadedFile.size / 1024 / 1024).toFixed(2)} MB</small>
                    </div>
                    <div style={{ display: "flex", gap: "0.5rem" }}>
                      <button
                        type="button"
                        className={classes.inactiveTab}
                        onClick={clearUploadedFile}
                        disabled={isUploading}
                        style={{ minWidth: "80px" }}
                      >
                        Clear
                      </button>
                    </div>
                  </div>

                  {/* Stock Classification and Category Selection */}
                  <div style={{ marginBottom: "1rem" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "1rem" }}>
                      <div>
                        <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "bold" }}>
                          Stock Classification *
                        </label>
                        <select
                          value={bulkStockClassification}
                          onChange={(e) => setBulkStockClassification(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "0.5rem",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            fontSize: "14px"
                          }}
                          disabled={isUploading}
                        >
                          <option value="">Select Classification</option>
                          {stockClassifications.map((classification) => (
                            <option key={classification.id} value={classification.id}>
                              {classification.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "bold" }}>
                          Stock Category *
                        </label>
                        <select
                          value={bulkStockCategory}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === '__add_category__') {
                              openAddCategoryModal(null, true);
                            } else {
                              setBulkStockCategory(val);
                            }
                          }}
                          style={{
                            width: "100%",
                            padding: "0.5rem",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            fontSize: "14px"
                          }}
                          disabled={isUploading}
                        >
                          <option value="">Select Category</option>
                          {stockCategories.map((category) => (
                            <option key={category.id} value={category.id}>
                              {category.name}
                            </option>
                          ))}
                          <option value="__add_category__">+ Add Category</option>
                        </select>
                      </div>
                    </div>

                    <button
                      type="button"
                      className={classes.activeTab}
                      onClick={handleUploadProducts}
                      disabled={isUploading || !bulkStockClassification || !bulkStockCategory}
                      style={{
                        minWidth: "120px",
                        opacity: (!bulkStockClassification || !bulkStockCategory) ? 0.6 : 1
                      }}
                    >
                      {isUploading ? (
                        <>
                          <Spinner animation="border" size="sm" /> Uploading...
                        </>
                      ) : (
                        "Upload Excel File"
                      )}
                    </button>
                  </div>

                  {isUploading && (
                    <div style={{ marginTop: "1rem" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <Spinner animation="border" size="sm" />
                        <span>Uploading Excel file to backend...</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Hidden file input */}
          <input
            id="fileInput"
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileUpload}
            style={{ display: 'none' }}
          />




          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th className={classes.productservice}>Product / Services</th>
                <th>Short name</th>
                <th>Description</th>
                <th>Stock Classification</th>
                <th>Stock Category</th>
                <th>Qty*</th>
                <th className={classes.priceRateCol}>Price/Rate*</th>
                {/* <th>Discount</th> */}
                <th>Unit (kg)</th>
                <th>Re-order Level</th>
                <th>
                  <button
                    type="button"
                    className={classes.addRowBtn}
                    onClick={handleAddRow}
                  >
                    +
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              {invoiceItems.length === 0 ? (
                <tr>
                  <td colSpan="11">
                    {type === "products" ? (
                      <div>
                        {products.length === 0 ? "Loading products..." : (
                          <ul>
                            {products.map((p, i) => (
                              <li key={i}>{p.name} - ₦{p.price}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ) : (
                      <div>
                        {services.length === 0 ? "Loading services..." : (
                          <ul>
                            {services.map((s, i) => (
                              <li key={i}>{s.name} - ₦{s.price}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              ) : (
                invoiceItems.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={item.name || ''}
                        onChange={(e) => handleChange(index, 'name', e.target.value)}
                      // placeholder="Enter Product/Service"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.short_name || ''}
                        onChange={(e) => handleChange(index, 'short_name', e.target.value)}
                      // placeholder="Enter Short Name"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.description || ''}
                        onChange={(e) => handleChange(index, 'description', e.target.value)}
                        placeholder="Enter description"
                      />
                    </td>
                    <td>
                      <select
                        value={item.stock_classification || ''}
                        onChange={(e) => handleChange(index, 'stock_classification', e.target.value)}
                      >
                        <option value="">Select Classification</option>
                        {stockClassifications.map((classification) => (
                          <option key={classification.id} value={classification.id}>
                            {classification.name}
                          </option>
                        ))}
                      </select>

                    </td>

                    <td>
                      <select
                        value={item.stock_category || ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === '__add_category__') {
                            openAddCategoryModal(index, false);
                          } else {
                            handleChange(index, "stock_category", val);
                          }
                        }}
                      >
                        <option value="">Select Category</option>
                        {stockCategories.map((category) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                        <option value="__add_category__">+ Add Category</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        value={item.qty}
                        onChange={(e) => handleChange(index, 'qty', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={item.unit_price}
                        className={classes.inputField}
                        onChange={(e) => handleChange(index, 'unit_price', e.target.value)}
                      />
                    </td>
                    {/* <td>
                      <input
                        type="number"
                        value={unitDiscount}
                        className={classes.inputField2}
                        onChange={(e) => setUnitDiscount(e.target.value)}
                      />
                    </td> */}
                    <td>

                      <input
                        type="text"
                        value={item.unit_of_measurement || ''}
                        onChange={(e) => handleChange(index, 'unit_of_measurement', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={item.re_order_level}
                        className={classes.reorderd}
                        onChange={(e) => handleChange(index, 're_order_level', e.target.value)}
                      />
                    </td>
                    <td>
                      <Trash2
                        size={16}
                        onClick={() => handleDeleteRow(index)}
                        className={classes.deleteIcon}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>2</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - {invoiceItems.length} of {invoiceItems.length}</span>
            </div>
          </div>
        </div>
        {/* Add Category Modal */}
        {showAddCategoryModal && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
            <div style={{ background: '#fff', padding: '1.25rem', borderRadius: 8, width: '420px', boxShadow: '0 6px 18px rgba(0,0,0,0.2)' }}>
              <h3 style={{ marginTop: 0 }}>Add Stock Category</h3>
              <div style={{ marginBottom: '0.75rem' }}>
                <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>Name</label>
                <input
                  type="text"
                  value={newCategoryName}
                  onChange={(e) => setNewCategoryName(e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: 4 }}
                />
              </div>
              <div style={{ marginBottom: '0.75rem' }}>
                <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>Description</label>
                <textarea
                  value={newCategoryDescription}
                  onChange={(e) => setNewCategoryDescription(e.target.value)}
                  rows={3}
                  style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: 4 }}
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                <button type="button" className={classes.cancelButton} onClick={() => setShowAddCategoryModal(false)} disabled={isCreatingCategory}>Cancel</button>
                <button
                  type="button"
                  className={classes.saveButton}
                  onClick={handleCreateCategory}
                  disabled={isCreatingCategory}
                >
                  {isCreatingCategory ? 'Creating...' : 'Create'}
                </button>
              </div>
            </div>
          </div>
        )}

        <div className={classes.actionButtons}>
          <button className={classes.cancelButton}>Cancel</button>
          <button
            className={classes.saveButton}
            type="button"
            onClick={handleCreateStock}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <Spinner animation="border" size="sm" /> Creating...
              </>
            ) : (
              "Create Stock"
            )}
          </button>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Newitemproducts;
